export default {
  button: {
    enable: 'Enable',
    disable: 'Disable',
    retrying: 'Retry',
    cancelRetrying: 'Cancel Retry',
    ok: 'Define',
    empty: 'Clear',
    counting: 'Counting',
    callCarCounting: 'Call Car Counting',
    callCarOutbound: 'CallCar Outbound',
    callCarinbound: 'CallCar Inbound',
    inboundInventory: 'Inbound Inventory',
    outboundInventory: 'Outbound Inventory',
    go: 'Go',
    destruction: 'Destruction Order',
    call: 'Call',
    upself: 'Receiving',
    seed: 'Seed',
    outbound: 'Sale',
    confirm: 'Confirm',
    cancel: 'Cancel',
    query: 'Query',
    reset: 'Reset',
    sendRCS: 'Send to RCS',
    fold: 'Fold',
    unfold: 'Unfold',
    detail: 'Detail',
    edit: 'Edit',
    editStorageRoom: 'Edit Storage Room',
    editZone: 'Edit Zone',
    editLocation: 'Edit Location',
    operate: 'Operate',
    reloadColumn: 'Reload Columns',
    reload: 'Reload',
    insertActived: 'Insert Actived',
    markCancel: 'Mark Cancel',
    save: 'Save',
    export: 'Export',
    add: 'Add',
    delete: 'Delete',
    addRole: 'Add Role',
    addStorageRoom: 'AddStorageRoom',
    addZone: 'AddZone',
    addLocation: 'AddLocation',
    addMenu: 'AddMenu',
    addChildrenMenu: 'AddChildrenMenu',
    addMethod: 'Add Method',

    refresh: 'Refresh',
    expConfirm: 'Export',
    exportTemplate: 'Export template',
    impConfirm: 'Import',
    addCapacity: 'Add Capacity',
    addProduct: 'Add Product',
    addBom: 'Add Bom',
    addMaterial: 'Add Material',
    delProduct: 'Del Product',
    delBom: 'Del Bom',
    delMateriel: 'Del Materiel',
    preview: 'Preview',
    print: 'Print',
    printTag: 'Print Tag',
    printCRO: 'Print CRO',
    printPWO: 'Print PWO',
    printLoadingOrder: 'Print Loading Order',
    cleanupStagingArea: 'Cleanup Staging Area',
    queryDetail: 'Query Detail',
    addContainer: 'Add Container',
    batchAddContainer: 'Batch Add Container',
    printOrder: 'printOrder',
    printConfirm: 'printConfirm',
    delivery: 'delivery',
    queryReversed: 'Query Reversed',
    obtain: 'Obtain',
    review: 'Review',
    assign: 'Assign',
    approval: 'Approval',
    grant: 'Grant',
    lock: 'Lock',
    unlock: 'Un Lock',
    modify: 'Modify',
    cancelReceiving: 'Cancel Receiving',
    submit: 'Submit',
    submitAndPrint: 'Submit&Print',
    addNeworder: 'Add Neworder',
    reject: 'Reject',
    shelfConfirm: 'Shelf Confirm',
    clear: 'Clear',
    taken: 'Taken',
    takenSaleOrder: 'Taken SaleOrder',
    addDetail: 'Add Detail',
    addCollect: 'Add Collect',
    tagging: 'Tagging',
    oddTagging: 'Odd Tagging',
    resetPassword: 'Reset Password',
    changePassword: 'Change Password',
    getFingerPrint: 'Get FingerPrint',
    cancelPutAway: 'Cancel PutAway',
    moveOrder: 'Move Order',
    inboundScan: 'Inbound Scan',
    goBack: 'Go Back',
    inboundComplete: 'Inbound Complete',
    outboundTaken: 'Outbound Taken',
    outboundComplete: 'Outbound Complete',
    commandActive: 'Command Active',
    increasePriority: 'Increase Priority',
    bindSeedingPosition: 'Bind Seeding Position',
    scanUniqueCode: 'Scan Unique Code',
    outboundCode: 'Outbound Code',
    appointLocation: 'Switch to Appoint Location',
    oneStepOutbound: 'Switch to One-Step Outbound',
    lockingStock: 'Locking Stock',
    unLockingStock: 'UnLocking Stock',
    checkConvertQualified: 'Check Convert Qualified',
    checkConvertUnqualified: 'Check Convert Unqualified',
    release: 'Release',
    unRelease: 'Un Release',
    queryByRequirement: 'QueryByRequirement',
    receiptComplete: 'Receipt Complete',
    beginReconciliation: 'Begin Reconciliation',
    batchAdd: 'Batch Add',
    invert: 'Invert',
    formatJson: 'Format Json',
    uploadTemplate: 'Upload Template',
    savePrintConfig: 'Save Print Config',
    savePrintTemplate: 'Save Print Template',
    editPrintTemplate: 'Edit Print Template',
    scanSupervisorCode: 'Scan Supervisor Code',
    dataMaintenance: 'Data Maintenance',
    printRejectLabel: 'Print Reject Label',
    printShelfLabel: 'Print Shelf Label',
    reviewPass: 'Review Pass',
    reviewReject: 'Review Reject',
    close: 'Close',
    rollback: 'Rollback',
    login: 'Login',
    reviewConfirmed: 'Review Confirmed',
    drawDraft: 'Draw Draft',
    drawInventory: 'Draw Inventory',
    search: 'Search',
    complete: 'Complete',
    errorMessage: 'Error Message',
    waveStatus: 'Wave Status',
    arrange: 'Arrange',
    addOrderToWave: 'Add Order To Wave',
    waveIssue: 'Wave Issue',
    waveReplenish: 'Wave Replenish',
    removeOrder: 'Remove Order',
    orderInvert: 'Order Invert',
    stage: 'Stage',
    sealing: 'Sealing',
    split: 'Split',
    shortPicking: 'Short Picking',
    rePrint: 'RePrint',
    printAfterConfirm: 'Print After Confirm',
    printGroupageDetail: 'Print Groupage Detail',
    previewShipmentPrint: 'Preview Shipment Print',
    printShipmentOrder: 'Print Shipment Order',
    printShipmentDifference: 'Print Shipment Difference',
    approve: 'Approve',
    destroyEntry: 'Destroy Entry',
    destroy: 'Destroy',
    maintain: 'Maintain',
    maintenancePlanGeneration: 'MaintenancePlanGeneration',
    printReplenishmentLabel: 'Print Replenishment Label',
    exchangeBox: 'Exchange Box',
    supervisionCodeCollection: 'Supervision Code Collection',
    scanBarcode: 'Scan Barcode',
    associativeEmptyBox: 'Associative Empty Box',
    bindExchangeBoxBarcode: 'Bind Exchange Box Barcode',
    reissue: 'Reissue',
    changeToDispatch: 'Change To Dispatch',
    invertAll: 'Invert All',
    obtainAll: 'Obtain All',
    issue: 'Issue',
    executeApprove: 'Execute Approve',
    log: 'Log',
    allocatePackingPosition: 'Allocate Packing Position',
    updateSeedingQuantity: 'Update Seeding Quantity',
    sending: 'Sending',
    waveSending: 'Wave Sending',
    detailSending: 'Detail Sending',
    copy: 'Copy',
    editAutoTaskUser: 'Edit AutoTask User',
    addLoadingOrder: 'Add Loading Order',
    addLoadingDetail: 'Add Loading Detail',
    deleteLoadingOrder: 'Delete Loading Order',
    deleteLoadingDetail: 'Delete Loading Detail',
    transferShipment: 'Transfer Shipment',
    oneClickEntry: 'One Click Entry',
    coldChainEdit: 'Cold Chain Edit',
    lightUp: 'Light Up',
    lightOff: 'Light Off',
    seedingConfirm: 'Seeding Confirm',
    checkIn: 'Check In',
    more: 'More'
  },
  placeholder: {
    pleaseInput: 'Please input',
    operate: 'Operate',
    createOrder: 'Create Order',
    add: 'Add',
    return: 'Return',
    save: 'Save',
    refresh: 'Refresh',
    expConfirm: 'Export',
    impConfirm: 'Import',
    returnOrderNo: 'Return Order No',
    receiptOrderNo: 'Receipt Order No',
    ownerName: 'Owner Name',
    itemNo: 'Item No',
    itemName: 'Item Name',
    lotNo: 'Lot No',
    showSearch: 'Enter Or DoubleClick',
    showTag: 'Please enter the import identification code (avoid repeated import)',
    application: 'Application',
    scanSupervisionCode: 'Scan Supervision Code',
    account: 'Account',
    password: 'Password',
    pleaseEnterItemNo: 'Please Enter Item No',
    pleaseEnterItemName: 'Please Enter Item Name',
    pleaseEnterOrderNo: 'Please Enter Order No',
    pleaseEnterCustomerNo: 'Please Enter Customer No',
    pleaseEnterCustomerName: 'Please Enter Customer Name',
    storageRoom: 'StorageRoom',
    zone: 'Zone',
    location: 'Location',
    inventoryClerk: 'Inventory Clerk',
    pleaseDoubleClickSelectItem: 'Please Double Click Select Item',
    pleaseDoubleClickSelectStorageRoom: 'Please Double Click Select StorageRoom',
    pleaseDoubleClickSelectLocation: 'Please Double Click Select Location',
    pleaseDoubleClickSelectContainer: 'Please Double Click Select Container',
    actualInventoryQuantity: 'Actual Inventory Quantity',
    pleaseEnterInventoryReason: 'Please Enter Inventory Reason...',
    no: 'No',
    operator: 'Operator',
    pleaseSelectOwner: 'Please Select Owner',
    pleaseSelectTransferType: 'Please Select Transfer Type',
    orderNo: 'order No',
    transferBarcode: 'transfer Barcode',
    itemBarcode: 'Item Barcode',
    pleaseEnterReason: 'Please Enter Reason...',
    pleaseEnterItemNoOrItemName: 'Please Enter Item No Or Item Name',
    pleaseEnterContainerNo: 'Please Enter Container No',
    pleaseEnterLocationNo: 'Please Enter Location No',
    pleaseEnterLotNo: 'Please Enter Lot No',
    pleaseEnterModel: 'Please Enter Model',
    pleaseEnterBarcode: 'Please Enter Barcode',
    pleaseEnterSerialNumber: 'Please Enter Serial Number',
    orderNoSearchTip: 'Please enter the order no',
    reviewDeskSelectTip: 'Please select the review desk',
    owner: 'owner',
    startTime: 'Start Time',
    endTime: 'End Time',
    maintenanceMeasure: 'Maintenance Measure',
    maintenanceAdvice: 'Maintenance Advice',
    inventoryStatus: 'Inventory Status',
    pleaseSelectTargetStorageRoom: 'Please Select Target StorageRoom',
    saleOrderNo: 'Sale Order No',
    purchaseOrderNo: 'Purchase Order No',
    countingOrderNo: 'Counting Order No',
    ASNOrderNo: 'ASN Order No',
    outboundOrderNo: 'Outbound Order No',
    supplierName: 'Supplier Name',
    mnemonicCode: 'Mnemonic Code',
    countingType: 'Counting Type',
    customerName: 'Customer Name',
    commandStatus: 'Command Status',
    commandId: 'Command Id',
    ReplenishmentBarcode: 'Replenishment Barcode',
    wave: 'Wave',
    pickingOrderNo: 'Picking Order No',
    taskGroup: 'Task Group',
    containerNo: 'Container No',
    loadingOrderNo: 'Loading Order No',
    packType: 'Pack Type',
    legalAttribute: 'Legal Attribute',
    brand: 'Brand',
    season: 'Season',
    storageRequest: 'Storage Requirements',
    dosageForm: 'DosageForm',
    storageLocation: 'Storage Location',
    exchangePosition: 'Exchange Position',
    seedingPosition: 'Seeding Position',
    packingPosition: 'Packing Position',
    stagingPosition: 'Staging Position',
    visualized: 'Visual packing',
    stagingCompleted: 'Staging Completed',
    reviewed: 'Reviewed',
    operationType: 'Operation Type',
    startTimeToEndTime: 'start Time —— End Time',
    pleaseSelectCountingType: 'Please Select Counting Type',
    customerNoTag: 'Replenish Not Customer Screening',
    waveTag: 'Replenish Not Wave Screening',
    itemFilter: 'ItemNo/MnemonicCode'
  },
  business: {
    label: {
      section: 'Section',
      side: 'A/B Side',
      toLoc: 'Platform number',
      msg: 'Message',
      businessOrderNo: 'Business Order No',
      orderNo: 'Order No',
      owner: 'Owner',
      orderType: 'Order Type',
      countingType: 'CountingType',
      orderTypeNo: 'Order Type No',
      orderTypeName: 'Order Type Name',
      itemBarcode: 'Item Barcode',
      itemType: 'Item Type',
      mechanicalLocking: 'Mechanical Locking',
      itemTypeA: '*Item Type',
      itemTypeNo: 'Item Type No',
      itemTypeName: 'Item Type Name',
      itemCategory: 'Item Category',
      orderStatus: 'Order Status',
      invoiceDate: 'Invoice Date',
      customer: 'Customer',
      indexNo: 'Index No',
      buyer: 'Purchaser',
      customerNo: 'Customer No',
      customerName: 'Customer Name',
      notes: 'Notes',
      customerId: 'Customer ID',
      ownerId: 'Owner ID',
      operator: 'Operator',
      approver: 'Approver',
      approved: 'Approved',
      itemNo: 'Item No',
      itemID: 'Item ID',
      ChineseName: 'Chinese Name',
      itemName: 'Item Name',
      specification: 'Specification',
      daysOfValid: 'Days Of Valid',
      daysOfExpirationNearly: 'Days Of Expiration Nearly',
      daysOfProductionNearly: 'Days Of Production Nearly',
      daysOfInspectionNearly: 'Days Of Inspection Nearly',
      daysOfMaintenanceNearly: 'Days Of Maintenance Nearly',
      batch: 'Batch',
      batchId: 'Batch Id',
      batchNo: 'Batch No',
      lotNo: 'Lot No',
      location: 'Location',
      ownerNo: 'Owner No',
      ownerName: 'Owner Name',
      enterpriseNo: 'Enterprise No',
      enterpriseName: 'Enterprise Name',
      queryMode: 'Query Mode',
      storageRoom: 'Storage Room',
      inventoryStatus: 'Inventory Status',
      qualityStatus: 'Quality Status',
      manufacturer: 'Manufacturer',
      producingArea: 'Producing Area',
      whetherOddNumber: 'Whether Odd Number',
      coldChains: 'Cold Chains',
      lockedQuantity: 'Locked Quantity',
      availableLockedQuantity: 'Available Locked Quantity',
      lockReasons: 'Lock Reasons',
      lockedCases: 'Locked Cases',
      lockedNumberOfEach: 'Locked Number Of Each',
      locker: 'Locker',
      lockedTime: 'Locked Time',
      internal: 'Internal',
      transferredFromQuantity: 'Transferred From Quantity',
      inboundQuantity: 'Inbound Quantity',
      inboundTag: 'Inbound Tag',
      inboundAssessOrder: 'Inbound Assess Order',
      inboundPutAwayOrder: 'Inbound PutAway Order',
      outboundQuantity: 'Outbound Quantity',
      replenishedToQuantity: 'Replenished To Quantity',
      replenishedFromQuantity: 'Replenished From Quantity',
      transferredToQuantity: 'Transferred To Quantity',
      availableOutboundQuantity: 'Available Outbound Quantity',
      containerNo: 'Container No',
      productionDate: 'Production Date',
      validUntil: 'Valid Until',
      uom: 'Uom',
      factor: 'Factor',
      innerFactor: 'InnerFactor',
      quantity: 'Quantity',
      impQty: 'Import Quantity',
      discrepancyQty: 'Discrepancy Quantity',
      model: 'Model',
      modelID: 'Model ID',
      modelName: 'Model Name',
      modelNameA: 'Model Name',
      serialNumber: 'Serial Number',
      number: 'Number',
      inventoryReason: 'Inventory Reason',
      lockedLocation: 'Locked Location',
      inventoryType: 'Inventory Type',
      showLocation: 'Show Location',
      shelver: 'Shelver',
      closer: 'Closer',
      remover: 'Remover',
      receiver: 'Receiver',
      importer: 'Importer',
      maker: 'Maker',
      receivingman: 'Receivingman',
      reviewer: 'Reviewer',
      inspector: 'Inspector',
      dispatcher: 'Dispatcher',
      dispatchingTime: 'Dispatching Time',
      issuer: 'Issuer',
      deliver: 'Deliver',
      submissionAdviceOperator: 'Submission Adviser',
      submissionAdviceContent: 'Submission Advice',
      approvalAdviceOperator: 'Approval Adviser',
      approvalAdviceContent: 'Approval Advice',
      reportAdviceOperator: 'Report Adviser',
      reportAdviceContent: 'Report Advice',
      destructionAdviceOperator: 'Destruction Adviser',
      destructionAdviceContent: 'Destruction Advice',
      upOrderNo: 'Up Order No',
      downSide: 'Down Side',
      receiptCompleted: 'Receipt Completed',
      allocateLocation: 'Allocate Location',
      shelvesNumber: 'Shelves Number',
      shelvesNumberOfEach: 'Shelves NumberOfEach',
      assessment: 'Assessment',
      item: 'Item',
      itemLotQuery: 'Item Lot Query',
      itemLot: 'Item Lot',
      lotDetail: 'Lot Detail',
      shlevesType: 'Shleves Type',
      appearance: 'Appearance',
      shape: 'Shape',
      roundingMode: 'Rounding Mode',
      robotArmNumber: 'Robot Number',
      separationOfLabel: 'Label Separation',
      label: 'Label',
      modelSecond: 'Model Second',
      modelFirst: 'Model First',
      modelThird: 'Model Third',
      modelFourth: 'Model Fourth',
      accordingOrder: 'According Order',
      accordingZone: 'According Zone',
      printProductionDate: 'Print Production Date',
      printValidUntil: 'Print Valid Until',
      purchaseOrderOperator: 'PurchaseOrder Operator',
      purchaseOrderSource: 'PurchaseOrder Source',
      purchaseOrderNo: 'PurchaseOrder No',
      returnReason: 'Return Reason',
      returnOrderNo: 'Return Order No',
      executed: 'Executed',


      //addByMaterialQuota
      productInfo: 'Product Info',
      category: 'Category',
      categoryName: 'Category Name',
      categoryNo: 'Category No',
      categoryClassification: 'Category Classification',
      bom: 'Bom',
      materialInfo: 'MaterialInfo',
      index: 'Index',
      materialName: 'Material Name',
      deviation: 'Deviation',
      deviationRatio: 'Deviation Ratio',
      master: 'Master',
      sourceOwnerName: 'Source Owner Name',
      sourceItemName: 'Source Item Name',
      targetOwnerName: 'Target Owner Name',
      targetItemName: 'Target Item Name',
      invoiceTime: 'Invoice Time',
      inspectTime: 'Inspect Time',
      shelvingTime: 'Shelving Time',
      numberOfOdd: 'Number Of Odd',
      numberOfPackages: 'Number Of Packages',
      numberOfItem: 'Number of Item',
      numberOfFcl: 'FCL',
      numberOfLcl: 'LCL',
      numberOfEach: 'Number of Each',
      numberOfRefrigeration: 'Number of Refrigeration',
      numberOfValuable: 'Number of Valuable',
      numberOfImportation: 'Number of Importation',
      numberOfPsychotropic: 'Number of Psychotropic',
      numberOfSpecial: 'Number of Special',
      numberOfPeptides: 'Number of Peptides',
      numberOfGift: 'Number of Gift',
      numberOfOthers: 'Number of Others',
      numberOfSupervised: 'Number of Supervised',
      standardCaseQuantity: 'Quantity of standard Case',
      amount: 'Amount',
      noOfSGA: 'No Of SGA',
      nameOfSGA: 'Name Of SGA',
      typeOfSGA: 'Type Of SGA',
      dirOfSGA: 'Dir Of SGA',
      orderTypeOfSGA: 'Order Type Of SGA',
      itemTypeOfSGA: 'Item Type Of SGA',
      pickMode: 'Pick Mode',
      orderOperator: 'Order Operator',
      beginSGA: 'Begin SGA',
      endSGA: 'End SGA',
      beginDate: 'Begin Date',
      endDate: 'End Date',
      date: 'Date',
      stockOutSGA: 'Stock Out SGA',
      PurchaseReturnSGA: 'Purchase Return SGA',
      type: 'Type',
      limitType: 'Limit Type',
      caseThreshold: 'CaseThreshold',
      queryTerms: 'Query Terms',
      addContainer: 'Add Container',
      print: 'Print',
      reviewConfirmed: 'Review Confirmed',
      SGA: 'SGA',
      time: 'Time',
      reversedItem: 'Reversed Item',
      workCompletionTime: 'Work Completion Time',
      worker: 'Worker',
      reviewPrintTime: 'Review Print Time',
      barcode: 'Barcode',
      reversed: 'Reversed',
      itemSpecification: 'itemSpecification',
      approvalNo: 'Approval No',
      pickingCompletionTime: 'Picking Completion Time',
      review: 'Review',
      obtainTime: 'Obtain Time',
      pickLocation: 'Pick Location',
      picker: 'Picker',
      inventoryTurnoverMode: 'Inventory Turnover Mode',
      stagingCompletion: 'Staging Completion',
      distributionDirection: 'Distribution Direction',
      upperNo: 'Upper No',
      typeNo: 'Type No',
      typeName: 'Type Name',
      physical: 'Physical',
      application: 'Application',
      pickUpMode: 'Pick Up Mode',
      lastRoadway: 'Last Roadway',
      nextRoadway: 'Next Roadway',
      host: 'Host',
      ip: 'Ip',
      mac: 'Mac',
      printer: 'Printer',
      warehouse: 'Warehouse',
      releasable: 'Releasable',
      modelControl: 'Model Control',
      codeInitial: 'CodeInitial',
      codeLength: 'Code Length',
      volume: 'Volume',
      halfVolume: 'Half Volume',
      targetLocation: 'Target Location',
      targetStorageRoom: 'Target StorageRoom',
      reason: 'Reason',
      moveOutLocation: 'Move Out Location',
      moveInLocation: 'Move In Location',
      putawayLocation: 'Putaway Location',
      moveOutContainer: 'Move Out Container',
      moveInContainer: 'Move In Container',
      actualCountQuantity: 'Actual Count Quantity',
      actualCountNumber: 'Actual Count Number',
      actualCountAmount: 'Actual Count Amount',
      no: 'No',
      noStar: 'No Star',
      noEnd: 'No End',
      name: 'Name',
      englishName: 'English Name',
      mnemonicCode: 'Mnemonic Code',
      mnemonicCodeA: 'Mnemonic Code',
      customerMnemonicCode: 'Customer MnemonicCode',
      customerMnemonicCodeA: 'Customer MnemonicCode',
      availableStock: 'Available Stock',
      packagingUnit: 'Packaging Unit',
      packageNumber: 'Package Number',
      packType: 'Pack Type',
      warehouseId: 'Warehouse Id',
      warehouseNo: 'Warehouse No',
      warehouseName: 'Warehouse Name',

      //customer & supplier
      logisticsInfo: 'LogisticsInfo',
      turnoverMode: 'Turnover Mode',
      businessman: 'Businessman',
      numberOfLot: 'Number Of Lot',
      outboundNumberOfLot: 'Outbound Number Of Lot',
      inner: 'Inner',
      downStream: 'Down Stream',
      upStream: 'Up Stream',
      dataSource: 'Data Source',
      addTime: 'Add Time',
      editTime: 'Edit Time',
      customerCategory: 'Category',
      code: 'Code',
      company: 'Company',
      contactor: 'Linkman',
      phone: 'Phone',
      email: 'Email',
      idType: 'Id Type',
      idNumber: 'Id Number',
      country: 'Country',
      regions: 'Regions',
      province: 'Province',
      city: 'City',
      district: 'District',
      town: 'Town',
      village: 'Village',
      street: 'Street',
      postalCode: 'Postal Code',
      detailAddress: 'Detail Address',
      direction: 'Direction',
      directionNo: 'Direction No',
      directionName: 'Direction Name',
      directionInfo: 'Direction Info',
      route: 'Route',
      routeNo: 'Route No',
      routeName: 'Route Name',
      routeInfo: 'Route Info',
      contact: 'Contact',
      orderOfLoading: 'Order Of Loading',
      defaults: 'Defaults',
      dayOfWeek: 'Day of Week',
      supplierNo: 'Supplier No',
      supplierName: 'Supplier Name',
      supplierCategory: 'Category',

      //employee
      employeeNo: 'Employee No',
      employeeName: 'Employee Name',
      department: 'Department',
      departmentNo: 'Department No',
      departmentName: 'Department Name',
      numberOfOrder: 'Number Of Order',
      numberOfTask: 'Number Of Task',
      numberOfCase: 'Number Of Case',
      signatureType: 'SignatureType',
      userNo: 'User No',
      username: 'Username',
      usernameA: 'Username',
      password: 'Password',
      specialAuthority: 'Special Authority',
      queryable: 'Queryable',
      operable: 'Operable',
      roleAuthority: 'Role Authority',
      itemTypeAuthority: 'Item Type Authority',
      orderTypeAuthority: 'Order Type Authority',
      ownerAuthority: 'Owner Authority',
      warehouseAuthority: 'Warehouse Authority',
      menuAuthority: 'Menu Authority',
      methodNo: 'Method No',
      methodName: 'Method Name',
      selectedMenu: 'Selected Menu',
      selectingMenu: 'Selecting Menu',

      menuId: 'Menu ID',
      menuName: 'Menu Name',
      menuNo: 'Menu No',
      menuOrdinal: 'Menu Ordinal',
      parameter: 'Parameter',
      url: 'URL',
      icon: 'Icon',
      reportNo: 'Report No',
      parentMenu: 'Parent Menu',
      leaf: 'Leaf',
      functional: 'Functional',
      shortcutKey: 'ShortcutKey',
      signable: 'Signable',
      unlockCategory: 'UnlockCategory',
      workstation: 'Workstation',

      //allUse
      serial: 'Serial',
      action: 'Action',
      zone: 'Zone',
      available: 'Available',
      importation: 'Importation',
      supervised: 'Supervised',
      abnormality: 'Abnormality',
      supervisionCodeInitial: 'Supervision Code Initial',
      supervisionCodeLength: 'Supervision Code Length',
      universalName: 'Universal Name',
      permitHolder: 'Permit Holder',
      newProduct: 'New Product',
      controlled: 'Controlled',
      coldStorage: 'Cold Storage',
      valuable: 'Valuable',
      special: 'Special',
      duplex: 'Duplex',
      tagPrice: 'Tag Price',
      retailPrice: 'Retail Price',
      wholesalePrice: 'Whole Sale Price',
      settlementPrice: 'Settlement Price',
      flittingCostPrice: 'Flitting Cost Price',
      costPrice: 'Cost Price',
      purchasePrice: 'Purchase Price',
      price: 'Price',
      positionType: 'Position Type',
      region: 'Region',
      unitedRegion: 'Region',
      storageRoomInfo: 'StorageRoom Info',
      zoneInfo: 'Zone Info',
      locationInfo: 'Location Info',
      //StorageRoom
      storageRoomNo: 'StorageRoom No',
      storageRoomName: 'StorageRoom Name',
      storageRoomType: 'StorageRoom Type',
      storageEnvironment: 'Storage Environment',
      storageClassification: 'Storage Classification',
      storageRequest: 'Storage Request',
      numberOfBarcode: 'Number Of Barcode',
      numberOfPickingOrder: 'Number Of Picking',
      exchangeStorageRoom: 'Exchange StorageRoom',
      caseOnly: 'Case Only',
      containerType: 'Container Type',
      allocable: 'Allocable',
      aggregate: 'Aggregate',
      checkable: 'Checkable',
      weighable: 'Weighable',
      serialNumberManagement: 'Serial Manage',
      tag: 'tag',
      reservedLocations: 'Reserved Locations',
      columnMonopoly: 'column Monopoly',
      // Zone
      zoneName: 'Zone Name',
      zoneNo: 'Zone No',
      zoneType: 'Zone Type',
      floor: 'Floor',
      fullload: 'Fullload',
      fetchMode: 'Fetch Mode',
      putawayMode: 'Putaway Mode',
      transmissionType: 'Transmission Type',
      pickingMode: 'Picking Mode',
      autoObtain: 'Auto Obtain',
      autoConfirm: 'Auto Confirm',
      singleWork: 'Single Work',
      //Location
      locationName: 'Location Name',
      locationNo: 'Location No',
      roadway: 'Roadway',
      row: 'Row',
      layer: 'Layer',
      column: 'Column',
      depth: 'Depth',
      locationType: 'Location Type',
      storageType: 'Storage Type',
      rackType: 'RackType',
      capacity: 'Capacity',
      standardCapacity: 'Standard Capacity',
      standardContainerCapacity: 'Standard Container Capacity',
      layers: 'Layers',
      units: 'Units',
      storageState: 'StorageState',
      locationStatus: 'Location Status',
      saleClassification: 'Sale Classification',
      abcClassification: 'ABC Classification',
      approvalValidUntil: 'Approval ValidUntil',
      pileupType: 'Pileup Type',
      length: 'Length',
      width: 'Width',
      height: 'Height',
      occupiedCapacity: 'Occupied Capacity',
      transferLine: 'Transfer Line',
      weight: 'Weight',
      shortNo: 'ShortNo',
      containerControl: 'Container Control',
      automatic: 'Automatic',
      locking: 'Locking',
      plannedQuantity: 'Planed Quantity',
      actualQuantity: 'Actual Quantity',
      actualNumber: 'Actual Number',
      actualOddNumber: 'Actual Odd Number',
      claimQuantity: 'Claim Quantity',
      asnOrderNo: 'Asn Order No',
      dosageForm: 'Dosage Form',
      receiptQuantity: 'Receipt Quantity',
      returnRejectQuantity: 'Return Reject Quantity',
      rejectedQuantityOfAcceptance: 'Accept Rejected Quantity',
      returnOperator: 'Return Operator',
      whetherPrint: 'Whether Print',
      plannedOddNumber: 'Planned Odd Number',
      plannedNumber: 'planned Number',
      checkConfirm: 'Check Confirm',
      stockOutNo: 'Stock Out No',
      shipmentMode: 'Shipment Mode',
      carrierName: 'Carrier Name',
      expressCode: 'Express Code',
      allocateMode: 'Allocate Mode',
      allocateOrdinal: 'Allocate Ordinal',
      shipOrder: 'Ship Order',
      operationType: 'Operation Type',
      receivable: 'Receivable',
      shippable: 'Shippable',
      scattered: 'Scattered',
      transferable: 'Transferable',
      transferableA: 'Transferable',
      countable: 'Countable',
      wrapping: 'Wrapping',
      fragile: 'Fragile',
      hazardous: 'Hazardous',
      liquid: 'Liquid',
      catchWeight: 'Catch Weight',
      visualized: 'Visual packing',
      transportable: 'Transportable',
      autoPalletization: 'Auto Palletization',
      separable: 'Separable',
      uShape: 'UShape',
      entire: 'Entire',
      chargeup: 'ChargeUp',
      inspectable: 'Inspectable',
      refundable: 'Refundable',
      autoReview: 'Auto Review',
      shortable: 'Shortable',
      oneStep: 'OneStep',
      depositable: 'Depositable',
      autoAsn: 'Auto generate Asn',
      autoReceiving: 'Auto Receiving',
      autoCompletion: 'Auto Completion',
      delegable: 'Delegable',
      exchangeable: 'Exchangeable',
      autoHandover: 'Auto Handover',
      autoApproval: 'Auto Approval',
      autoDistribution: 'Auto Distribution',
      convertible: 'Convertible',
      reversible: 'Reversible',
      coding: 'Coding',
      producible: 'Producible',
      autoPacking: 'Auto Packing',
      autoRelease: 'Auto Release',
      distributionType: 'Distribution Type',
      pickupMode: 'Pickup Mode',
      pickupModeOrdinal: 'PickupModeOrdinal',
      autoStaging: 'Auto Staging',
      autoIssue: 'Auto Issue',
      inventoryState: 'Inventory State',
      transitional: 'Transitional',
      remainder: 'Remainder',
      sourceInventoryState: 'Source Inventory State',
      targetInventoryState: 'Target Inventory State',
      ordinal: 'Ordinal',
      role: 'Role',
      roleNo: 'Role No',
      roleName: 'Role Name',
      post: 'Post',
      lossQuantity: 'Loss Quantity',
      release: 'Release',
      upperBound: 'UpperBound',
      lowerBound: 'LowerBound',
      approvalContentResult: 'ApprovalContentResult',
      checkProject: 'Check Project',
      checkStandard: 'Check Standard',
      checkResult: 'Check Result',
      releaseApprovalState: 'Release Approval State',
      releaseNo: 'Release No',
      checkNo: 'Check No',
      qualityNo: 'Quality No',
      applyTime: 'Apply Time',
      rejectedReason: 'Rejected Reason',

      commandId: 'Command Id',
      commandGroup: 'Command Group',
      commandStatus: 'Command Status',
      whetherActive: 'Whether Active',
      theRoadWay: 'The RoadWay',
      newRoadWay: 'New RoadWay',
      thePlatform: 'The Platform',
      priority: 'Priority',
      operatingType: 'Operating Type',
      generatedTime: 'Generated Time',
      whetherWeigh: 'Whether Weigh',
      whetherReview: 'Whether Review',
      exceptionMessage: 'Exception Message',
      sourceLocation: 'Source Location',
      sourceZone: 'SourceZone',
      sourceStorageRoom: 'SourceStorageRoom',
      sourceActivated: 'SourceActivated',
      targetActivated: 'TargetActivated',
      targetZone: 'TargetZone',
      timeInterval: 'Time Interval',
      invoiceMember: 'Invoice Member',
      inventoryStatusChange: 'Inventory Status Change',
      treatmentSuggestion: 'Treatment Suggestion',
      parameterMeaning: 'Parameter Meaning',
      parameterValue: 'Parameter Value',
      parameterNote: 'Parameter Note',
      parameterName: 'Parameter Name',
      parameterType: 'Parameter Type',
      customized: 'Customized',
      //dictionary
      dictionary: 'Dictionary',
      dictionaryNo: 'Dictionary No',
      dictionaryName: 'Dictionary Name',
      dictionaryType: 'Dictionary Type',
      dictionaryValue: 'Dictionary Value',
      dictionaryList: 'Dictionary List',
      dictionaryInfo: 'Dictionary Info',
      alignment: 'Alignment',
      displayMode: 'Display Mode',
      fieldType: 'Field Type',
      fieldLength: 'Field Length',
      fieldPrecision: 'Field Precision',
      fieldOrdinal: 'Field Ordinal',
      fieldContent: 'Field Content',
      fieldId: 'Field ID',
      fieldNo: 'Field No',
      fieldName: 'Field Name',
      fieldList: 'Field List',
      fieldInfo: 'Field Info',
      pickingOrderNo: 'PickingOrder NO',
      taskGroup: 'Task Group',
      identifier: 'Identifier',
      printed: 'Printed',
      invQuantity: 'Inventory Quantity',
      id: 'ID',


      warehouseAddress: 'Warehouse Address',
      operate: 'Operate',
      autoPrint: 'AutoPrint',
      uploadConfigs: 'UploadConfigs',
      barcode2: 'BarcodeHistory',
      messageInfo: 'This function is applicable to online or moving. It can generate inventory in batch. It can\'t be cancelled after saving. Please be careful!',
      identificationCode: 'Identification Code',
      importDate: 'Import Date',
      messageDate: 'Please select the start and end date',
      state: 'State',
      pleaseSelect: 'pleaseSelect',
      all: 'ALL',
      noConfirmOrder: 'No Confirmed Order',
      confirmedOrder: 'Confirmed Order',
      received: 'Received',
      receipt: 'Receipt',
      drawer: 'Drawer',
      auditor: 'Auditor',
      confirmationTime: 'Confirmation time',
      pending: 'Pending',
      delivered: 'Delivered',
      operationTime: 'Operation Time',
      lotId: 'Lot ID',
      lot: 'Lot',
      returnAcceptQuantity: 'Return Accept Quantity',
      purchaseOrder: 'PurchaseOrder No',
      unallocatedQuantity: 'Unallocated Quantity',
      original: 'Original',
      native: 'Native',
      color: 'Color',
      colorId: 'Color ID',
      colorName: 'Color',
      size: 'Size',
      sizeId: 'size ID',
      sizeName: 'size',
      serialNumberId: 'SerialNumber ID',
      serialNumberNo: 'SerialNumber',
      logicalStore: 'LogicalStore',
      logicalStoreNo: 'LogicalStore No',
      logicalStoreName: 'LogicalStore Name',
      parentLogicalStore: 'Parent LogicalStore',
      inboundWorkstation: 'Inbound Platform',
      arrivalTime: 'Arrival Time',
      call: 'Call Car',
      fastorder: 'Is it an urgent order',
      upself: 'Receiving',
      locationBarcode: 'Location Barcode',
      noStock: 'No Stock',
      inStock: 'In Stock',
      same: 'Same Goods Location',
      currentLocation: 'Current Location',
      storageLocationDiagram: 'Storage Location Diagram',
      outboundComplete: 'Outbound Complete',
      seedComplete: 'Seed Complete',
      callComplete: 'Call Complete',
      positionNo: 'position No',
      returnGoods: 'Return Goods',
      noReturnGoods: 'No Return Goods',
      lessnessQuantity: 'Lessness Quantity',
      basket: 'Basket No',
      seedQuantity: 'Seed Quantity',
      callCarWorkStation: 'Call Car WorkStation',
      stock: 'stock',
      sourceContainer: 'Source Container',
      targetContainer: 'Target Container',
      countingTime: 'Counting Time',
      countingOperator: 'Counting Operator',
      balance: 'Balance',
      grossBalance: 'Gross Balance',
      receiptOrderNo: 'Receipt Order No',
      shipmentOrderNo: 'Shipment Order No',
      allocateQuantity: 'Allocate Quantity',
      putawayQuantity: 'Putaway Quantity',
      receivingTime: 'Receiving Time',
      deliveryQuantity: 'Delivery Quantity',
      deliveryTime: 'Delivery Time',
      errorMessage: 'Error Message',
      errorTimes: 'Error Times',
      totalLocation: 'Total Location',
      freeLocation: 'Free Location',
      lockingLocation: 'Locking Location',
      locationProgress: 'Location Progress',
      saleOrderNo: 'SaleOrder No',
      tempControlMode: 'Temp Control Mode',
      departureTime: 'Departure Time',
      departureTemp: 'Departure Temp',
      arrivalTemp: 'Arrival Temp',
      maximumTemp: 'Maximum Temp',
      minimumTemp: 'Minimum Temp',
      conveyance: 'Conveyance',
      wave: 'Wave',
      shortName: 'Short Name',
      classification: 'Classification',
      address: 'Address',
      mergeOrder: 'MergeOrder',
      reserveOnly: 'ReserveOnly',
      taskId: 'TaskId',
      shipmentBarcode: 'Shipment Barcode',
      checkoutContainer: 'CheckoutContainer',
      checkoutLocation: 'CheckoutLocation',
      appendageSign: 'AppendageSign',
      pickingStartTime: 'PickingStartTime',
      pickingFinishTime: 'PickingFinishTime',
      exchangePosition: 'ExchangePosition',
      exchangeContainer: 'ExchangeContainer',
      exchangingPositionAllocatedTime: 'ExchangingPositionAllocatedTime',
      exchangeTime: 'ExchangeTime',
      exchanger: 'Exchanger',
      seedingPosition: 'SeedingPosition',
      seedingContainer: 'SeedingContainer',
      seedingPositionAllocatedTime: 'SeedingPositionAllocatedTime',
      seeder: 'Seeder',
      seedingStartTime: 'SeedingStartTime',
      seedingFinishTime: 'SeedingFinishTime',
      visualReviewedTime: 'VisualReviewedTime',
      seedingMode: 'SeedingMode',
      packingMode: 'PackingMode',
      packingPosition: 'PackingPosition',
      packingContainer: 'PackingContainer',
      packingPositionAllocatedTime: 'PackingPositionAllocatedTime',
      packer: 'Packer',
      packingStartTime: 'PackingStartTime',
      packingFinishTime: 'PackingFinishTime',
      bigRegion: 'BigRegion',
      stagingRegion: 'StagingRegion',
      stagingPosition: 'StagingPosition',
      stagingType: 'StagingType',
      conveyor: 'Conveyor',
      stagingReviewer: 'StagingReviewer',
      reviewStartTime: 'ReviewStartTime',
      reviewFinishTime: 'ReviewFinishTime',
      activated: 'Activated',
      autoSeeding: 'AutoSeeding',

      prioritized: 'Prioritized',
      pickingFirst: 'Picking First',
      availableQuantity: 'AvailableQuantity',
      config: 'Config',
      menu: 'Menu',
      menuDetail: 'Menu Detail',
      roleList: 'Role List',
      roleMenu: 'Role Menu',
      jsonData: 'Json Data',
      validInfo: 'Valid Info',
      value: 'Value',
      sourcePosition: 'Source Position',
      targetPosition: 'Target Position',
      backend: 'Backend',
      flowType: 'Flow Type',
      employeePost: 'Employee Post',
      printNo: 'Print No',
      printName: 'Print Name',
      printStatement: 'Print Statement',
      printTemplate: 'Print Template',
      paperLength: 'Paper Length',
      paperWidth: 'Paper Width',
      paperSize: 'Paper Size',
      templatePath: 'Template Path',
      returnList: 'Return List',
      receivingList: 'Receiving List',
      saleReturn: 'Sale Return',
      receiving: 'Receiving',
      returnType: 'Return Type',
      receivingType: 'Receiving Type',
      orderStatusA: 'Order Status',
      invoiceQuantity: 'Invoice Quantity',
      contactMan: 'Contact Man',
      contactPhone: 'Contact Phone',
      enterprise: 'Enterprise',
      orderStrategy: 'Order Strategy',
      waveStrategy: 'Wave Strategy',
      pickingContainerType: 'Picking Container Type',
      additionPickingMode: 'Addition Picking Mode',
      weightDeviation: 'Weight Deviation',
      orderSplitting: 'Order Splitting',
      taskPrebuilt: 'Task Prebuilt',
      orderProperty: 'Order Property',
      hotline: 'Hotline',
      completed: 'Completed',
      sent: 'Sent',
      sendingErp: 'Sending Erp',
      matrixSortingMode: 'Matrix Sorting Mode',
      alternateType: 'Alternate Type',
      invertible: 'Invertible',
      supplemental: 'Supplemental',
      temporary: 'Temporary',
      autoSubmit: 'Auto Submit',
      autoRetry: 'Auto Retry',
      autoInversionApproval: 'Auto Inversion Approval',
      autoCleanup: 'Auto Cleanup',
      goback: 'Go Back',
      carrier: 'Carrier',
      position: 'Position',
      currentPosition: 'Current Position',
      lastPosition: 'Last Position',
      traceNo: 'Trace No',
      pickingOrder: 'Picking Order',
      destination: 'Destination',
      workload: 'Workload',
      replenishSourceZone: 'Replenish Source Zone',
      replenishTargetZone: 'Replenish Target Zone',
      obtainTimes: 'Obtain Times',
      handover: 'Handover',
      vehicleNo: 'Vehicle No',
      vehicleName: 'Vehicle Name',
      vehicleType: 'Vehicle Type',
      vehicleInPlaceStatus: 'Vehicle In Place Status',
      ownerEnterprise: 'Owner Enterprise',
      driver: 'Driver',
      vehicleDispatched: 'Dispatched',
      status: 'Status',
      qualityStandard: 'Quality Standard',
      expirationTime: 'Expiration Time',
      practiceNo: 'Practice No',
      approveDate: 'Approve Date',
      licenseNo: 'License No',
      permissionNo: 'Permission No',
      effectiveTime: 'Effective Time',
      arrivalQuantity: 'Arrival Quantity',
      returnCustomer: 'Return Customer',
      supplier: 'Supplier',
      inspection: 'Inspection',
      inboundStorageRoom: 'Inbound Storage Room',
      receiptConclusion: 'Receipt Conclusion',
      returnTotalQuantity: 'Return Total Quantity',
      receiptTotalQuantity: 'Receipt Total Quantity',
      locationLimit: 'Location Limit',
      unacceptedQuantity: 'Unaccepted Quantity',
      unreceivedQuantity: 'Unreceived Quantity',
      rejectedQuantityOfReturn: 'Rejected Quantity Of Return',
      receivedQuantity: 'Received Quantity',
      inspectedQuantity: 'Inspected Quantity',
      acceptedQuantity: 'Accepted Quantity',
      legalAttribute: 'Legal Attribute',
      brand: 'Brand',
      season: 'Season',
      cases: 'Cases',
      SmallPackUnit: 'Small Pack Unit',
      QuantityOfInnerPack: 'Quantity Of Inner',
      QuantityOfLargePack: 'Quantity Of Large',
      scanned: 'Scanned',
      supervisionCode: 'Supervision Code',
      deleteSupervisionCode: 'Delete Supervision Code',
      totalQuantity: 'Total Quantity',
      startTime: 'Start Time',
      endTime: 'End Time',
      palletNo: 'Pallet No',
      returnMethod: 'Return Method',
      obtainedQuantity: 'Obtained Quantity',
      countingOrderNo: 'Counting Order No',
      sourceLogicalStore: 'Source Logical Store',
      transferQuantity: 'Transfer Quantity',
      data: 'data',
      scheduleType: 'Schedule Type',
      ordersCount: 'Orders Count',
      inverseQuantity: 'Inverse Quantity',
      reviewDesk: 'Desk',
      turnoverBox: 'Container',
      storageLocation: 'Storage Loc',
      groupage: 'Groupage',
      issueStartTime: 'Issue Start Time',
      issueFinishTime: 'Issue Finish Time',
      issueTime: 'Issue Time',
      stagingArea: 'Staging Area',
      printTimes: 'Print Times',
      unqualifiedQuantity: 'Unqualified Quantity',
      unqualifiedReason: 'Unqualified Reason',
      rejectedQuantity: 'Rejected Quantity',
      important: 'Important',
      completeMaintenance: 'Complete Maintenance',
      maintenanceQuantity: 'Maintenance Quantity',
      maintenanceMeasure: 'Maintenance Measure',
      maintenanceAdvice: 'Maintenance Advice',
      existingInventory: 'Existing Inventory',
      sourceInventoryQuantity: 'Source Inventory Quantity',
      changeBoxQuantity: 'Change Box Quantity',
      taskType: 'Task Type',
      caseOutBound: 'Case OutBound:',
      seedingReplenishmentExchangeBox: 'Seeding Replenishment Exchange Box:',
      tailBoxExchangeBox: 'Tail Box Exchange Box:',
      scanContainer: 'Scan Container',
      countingTask: 'Counting Task',
      restInventory: 'Rest Inventory',
      collectQuantity: 'Collect Quantity',
      collectTime: 'Collect Time',
      fallible: 'Fallible',
      multiple: 'Multiple',
      seedingQuantity: 'Seeding Quantity',
      reviewQuantity: 'Review Quantity',
      true: 'True',
      false: 'False',
      actived: 'Actived',
      sourceRoadway: 'Source Roadway',
      targetRoadway: 'Target Roadway',
      weighed: 'Weighed',
      supplyQuantity: 'Supply Quantity',
      sourceSupplyQuantity: 'Source Supply Quantity',
      targetSupplyQuantity: 'Target Supply Quantity',
      orderCount: 'Order Count',
      numberOfPlasticBox: 'Number of Plastic Box',
      numberOfCartonBox: 'Number of Carton Box',
      numberOfInsulationBox: 'Number of Insulation Box',
      loadingOrderNo: 'Loading Order No',
      customerCount: 'Customer Count',
      dock: 'Dock',
      materialStatistics: 'Material Statistics',
      reviewStatistics: 'Review Statistics',
      shelfStatistics: 'Shelf Statistics',
      unDeliveryStatistics: 'UnDelivery Statistics',
      coldStatistics: 'Cold Statistics',
      autoReceipt: 'Auto Receipt',
      autoAccepting: 'Auto Accepting',
      autoPutaway: 'Auto Putaway',
      PrintOrNot: 'Print',
      inspectionType: 'Inspection Type',
      minValue: 'Min Value',
      maxValue: 'Max Value',
      sampleValue: 'Sample Value',
      planCycle: 'Plan Cycle',
      waveCount: 'Wave Count',
      appointed: 'Appointed',
      pickingCompleted: 'Picking Completed',
      hasInversion: 'Has Inversion',
      inverse: 'Inverse',
      stagingCompleted: 'Staging Completed',
      arranged: 'Arranged',
      outlets: 'Outlets',
      numberOfLocations: 'NumberOfLocations',
      numberOfContainers: 'NumberOfContainers'
    }
  },
  radio: {
    itemInformation: 'Item Information',
    showLocation: 'Show Location',
    containerInformation: 'Container Information'
  },
  tab: {
    itemTable: 'Item List',
    itemInformation: 'Item Information',
    locationLimit: 'Location Limit',
    inventoryLimit: 'Inventory Limit',
    detailsInformation: 'Details Information',
    customerList: 'Customer List',
    supplierList: 'Supplier List',
    customerInformation: 'Customer Information',
    addressInformation: 'Address Information',
    order: 'Order',
    orderDetails: 'Order Details',
    details: 'Details',
    packInfo: 'Packs',
    lotInfo: 'Lots',
    supplierInformation: 'Supplier Information',
    enterpriseList: 'Enterprise List',
    warehouseList: 'Warehouse List',
    stagingArea: 'Staging Area',
    cleanupStagingArea: 'Cleanup Staging Area',
    stagingType: 'Staging Type',
    employeeTable: 'Employee Table',
    employeeDetail: 'Employee Detail',
    employeeMenu: 'Employee Menu',
    employeeInfo: 'Employee Info',
    arrangeList: 'Arrange List',
    locked: 'Locked',
    unLocked: 'UnLocked',
    versionInfo: 'Version Info',
    assistInfo: 'Assist Info',
    itemBaseInfo: 'Item Base Info',
    itemDetail: 'Item Detail',
    obtainedOrder: 'Obtained Order',
    unObtainOrder: 'UnObtain Order',
    inventoryInfo: 'Inventory Info',
    countingOrder: 'Counting Order',
    inventoryMerge: 'InventoryMerge Order',
    orderType: 'Order Type',
    pickupMode: 'Pickup Mode',
    printList: 'Print List',
    printConfig: 'Print Config',
    warehouseData: 'Warehouse Data',
    conveyorConfig: 'Conveyor Config',
    distributionContainerConfig: 'Distribution Container Config',
    automationConfig: 'Automation Config',
    autoTaskUserConfig: 'Auto Task User Config',
    storageRoomData: 'Storage Room Data',
    shipmentRule: 'Shipment Rule',
    zoneData: 'Zone Data',
    storageRoomRegion: 'Storage Room Region',
    replenishmentRule: 'Replenishment Rule',
    workstationConfig: 'Workstation Config',
    pickingModeConfig: 'Picking Mode Config',
    mondayDelivery: 'Monday',
    tuesdayDelivery: 'Tuesday',
    wednesdayDelivery: 'Wednesday',
    thursdayDelivery: 'Thursday',
    fridayDelivery: 'Friday',
    saturdayDelivery: 'Saturday',
    sundayDelivery: 'Sunday',
    asnQuery: 'ASN Query',
    asnCreate: 'ASN Create',
    documentInformation: 'Document Information',
    coldChainTemperature: 'Cold Chain Temperature',
    inspectionQuery: 'Inspection Query',
    inspection: 'Inspection',
    shelfByOrder: 'Shelf By Order',
    shelfByArgs: 'Shelf By Args',
    shelfByStereoscopic: 'Shelf By Stereoscopic',
    receivingList: 'Receiving List',
    loginTab: 'Account--Password--Login',
    countingDetail: 'counting Detail',
    waveArrange: 'Wave Arrange',
    waveIssue: 'Wave Issue',
    invoiceDetails: 'Invoice Details',
    unStage: 'UnStage',
    unReview: 'UnReview',
    taskView: 'Task View',
    internalReview: 'Internal Review',
    orderInfo: 'Order Info',
    disqualificationOrder: 'Disqualification Order',
    orderDetail: 'Order Detail',
    exchangeBox: 'exchange Box',
    exchangeBoxList: 'exchange Box List',
    seedingDetail: 'Seeding Detail',
    seedingList: 'Seeding List',
    unArrangedOrder: 'UnArranged Order',
    arrangedOrder: 'Arranged Order',
    unIssueLoadingOrder: 'UnIssue Loading Order',
    issuedLoadingOrder: 'Issued Loading Order',
    autoAcceptanceConfig: 'Auto Acceptance Config',
    purchaseOrderQuery: 'Purchase Order Query',
    purchaseOrderCreate: 'Purchase Order Create',
    saleOrderQuery: 'Sale Order Query',
    saleOrderCreate: 'Sale Order Create',
    ownerData: 'Owner Data',
    logicalStoreData: 'Logical Store Data',
    inspectionConfig: 'Inspection Config',
    caseTag: 'Case Tag',
    eachTag: 'Each Tag',
    replenishTag: 'Replenish Tag',
    lightUp: 'Light Up',
    lightOff: 'Light Off'
  },
  divider: {
    itemBasicInformation: 'Item Basic Information',
    beforeAdjustment: 'Before Adjustment',
    adjustmentAfter: 'Adjustment After',
    stagingAreaTypeDetail: 'Staging Area Type Detail',
    employeeBaseInformation: 'Employee Base Information',
    authorityInformation: 'Authority Information',
    orderMessage: 'Order Message',
    detailMessage: 'Detail Message',
    transferDetails: 'Transfer Details',
    replenishmentDetail: 'Replenishment Detail',
    orderDetail: 'Order Detail',
    configurationList: 'Configuration List',
    configurationDetails: 'Configuration Details',
    bulkEdit: 'Bulk Edit:',
    conversionDetail: 'Conversion Detail'
  },
  col: {
    selectModifyProject: 'Select Modify Porject',
    container: 'Container',
    location: 'Location',
    batchNo: 'Batch No',
    pack: 'Pack',
    quantity: 'Quantity',
    version: 'Version',
    serialNumber: 'Serial Number'
  },
  form: {
    validateInput: 'Please input' + ' ',
    validateSelector: 'Please select one' + ' '
  },
  message: {
    pleaseSelect: 'Please select "{0}"',
    pleaseSelectFirst: 'Please first select' + ' ',
    pleaseInput: 'Please input' + ' ',
    waveAddOrderTip: 'Please input wave and select the order',
    switchLanguage: 'Switch need login',
    switchLanguageTip: 'Are you sure to switch language?',
    deleteMenu: 'Unable to restore after deleting menu',
    deleteMenuTip: 'Are you sure to delete this menu?',
    cannotBeEmpty: 'Can not be empty',
    deleteSuccess: 'Delete Success',
    deleteFailed: 'Delete Failed',
    saveSuccess: 'Save Success',
    saveFailed: 'Save Failed',
    pleaseInputAccount: 'Please input account',
    pleaseInputPassword: 'Please input password',
    tip: 'Tip',
    confirmLogout: 'Are you sure to logout?',
    confirmSwitchWarehouse: 'Are you sure to switch warehouse?',
    confirmDeleteTip: 'Are you sure to delete?',
    selectTip: 'Please select data first',
    arrangeSelectTip: 'Please select arrange data first',
    noDataSaveTip: 'No data to save',
    canNotBeEmptyTip: ' "{0}"can not be empty, please check',
    menuAddTip: 'If you want to add a new menu, care about role authority',
    issueSuccess: 'Issue Success',
    operationSuccess: 'Operation Success'
  },
  menu: {
    //system
    main: 'Main',
    common: 'Common',
    personalSetting: 'Personal Setting',
    personalCenter: 'Personal Center',
    menuSearch: 'Menu Search',
    recentlyVisited: 'Recently Visited',
    accountSetting: 'Account Setting',
    calculator: 'Calculator',
    switchWarehouse: 'Switch Warehouse',
    logout: 'Logout',
    dashboard: 'dashboard',
    authorityManage: 'Authority Manage',
    others: 'Others',

    //configuration
    index: 'Index',
    configuration: 'Configuration',
    configNavigation: 'Config Navigation',
    menuMaintenance: 'Menu Maintenance',
    roleAuthority: 'Role Authority',
    dictionaryMaintenance: 'Dictionary Maintenance',
    systemParameterSetting: 'Parameter Settings',
    validConfig: 'Valid Config',
    seedingPositionConfig: 'Seeding Position Config',
    packingPositionConfig: 'Packing Position Config',
    layerLocking: 'Layer Locking',
    rowLocking: 'Row Locking',
    pickupModeMaintenance: 'Pickup Mode Maintenance',
    inventoryStateConfig: 'Inventory State Config',
    inventoryStateSwitchConfig: 'Inventory State Switch',
    approveConfig: 'Approve Config',
    locationLimitMaintenance: 'Location Limit Maintenance',
    employeeArrangement: 'Employee Arrangement',
    autoTaskUserConfig: 'Auto Task User Config',
    autoPrintConfig: 'Auto Print Config',
    systemPrintConfig: 'System Print Config',

    //baseData
    baseData: 'Base Data',
    enterpriseMaintain: 'Enterprise Maintain',
    warehouseMaintain: 'Warehouse Maintain',
    ownerMaintain: 'Owner Maintain',
    itemMaintain: 'Item Maintain',
    itemTypeMaintain: 'Item Type Maintain',
    lotMaintain: 'Lot Maintain',
    supplierData: 'Supplier Data',
    customerData: 'Customer Data',
    stagingTypeMaintain: 'Staging Type Maintain',
    orderTypeMaintain: 'Order Type Maintain',
    containerTypeMaintain: 'Container Type Maintain',
    containerMaintain: 'Container Maintain',
    conveyorMaintain: 'Conveyor Maintain',
    storageRoomManage: 'Storage Room Manage',
    storageRoomData: 'Storage Room Data',
    zoneData: 'Zone Data',
    locationData: 'Location Data',
    addressManagement: 'Address Management',
    vehicleMaintain: 'Vehicle Maintain',
    directionMaintain: 'Direction Maintain',
    employeeData: 'Employee Data',

    //inbound
    inbound: 'Inbound',
    asnMake: 'ASN Make',
    receiving: 'Receiving',
    inspect: 'inspect',
    shelf: 'Shelf',
    receiptClose: 'Receipt Close',
    receiptModify: 'Receipt Modify',
    receiptPrint: 'Receipt Print',

    //outbound
    outbound: 'Outbound',
    scheduleErrorHandle: 'Schedule Error Handler',
    shipmentDispatch: 'Shipment Dispatch',
    appointDispatch: 'Appoint Dispatch',
    oneStepDispatch: 'One Step Dispatch',
    insufficientInventory: 'Insufficient Inventory',
    shortableDispatch: 'Shortable Dispatch',
    shortableReview: 'Shortable Order Review',
    shipmentOrderControl: 'Shipment Order Control',
    waveStage: 'Wave Stage',
    containerPacking: 'Container Packing',
    packingPositionMonitor: 'Packing Position Monitor',
    shipmentPrint: 'Shipment Print',
    viewSeeding: 'View Seeding',
    pickingOrderPacking: 'PickingOrder Packing',
    outBoundTagPrint: 'Outbound Tag Print',

    //returnManagement
    returnManagement: 'Return Management',
    purchaseReturnExecution: 'Purchase Return Execution',
    purchaseReturnReview: 'Purchase Return Review',
    saleReturn: 'Sale Return',
    returnDocument: 'Return Document',

    //warehouseManagement
    warehouseManagement: 'Warehouse Management',
    inventoryPlan: 'Counting Plan',
    temporaryCounting: 'Temporary Counting',
    countingApprove: 'Counting Approve',
    equipmentMovement: 'Equipment Movement',
    normalMovementMake: 'Normal Movement Make',
    normalMovementShelf: 'Normal Movement Shelf',
    locationAdjust: 'Location Adjust',
    inventoryLockOrUnlock: 'Inventory Lock/Unlock',
    activeReplenishment: 'Active Replenishment',
    deviceMonitor: 'Device Monitor',

    //qualityControl
    qualityControl: 'Quality Control',
    disqualificationManagement: 'Defects Management',
    disqualificationApply: 'Disqualification Apply',
    disqualificationConfirm: 'Disqualification Confirm',
    disqualificationDestroyApply: 'Destroy Apply',
    disqualificationDestroyConfirm: 'Destroy Confirm',
    disqualificationQuery: 'Disqualification Query',
    maintenance: 'Maintenance',
    maintenanceConfig: 'Maintenance Config',
    maintenancePlan: 'Maintenance Plan',
    maintenanceQuery: 'Maintenance Query',
    inventoryStatusChange: 'Inventory Status Change',

    //deliveryManage
    deliveryManage: 'Delivery Manage',
    deliveryLoading: 'Delivery Loading',
    deliveryArrange: 'Delivery Arrange',
    deliveryIssue: 'Delivery Issue',
    deliveryConfirm: 'Delivery Confirm',

    //query
    query: 'Query',
    orderTrace: 'Order Trace',
    purchaseOrderQuery: 'Purchase Order Query',
    asnOrderQuery: 'ASN Order Query',
    receiptOrderQuery: 'Receipt Order Query',
    saleOrderQuery: 'Sale Order Query',
    shipmentOrderQuery: 'Shipment Order Query',
    loadingOrderQuery: 'Loading Order Query',
    detailQuery: 'Detail Query',
    purchaseDetailQuery: 'Purchase Query',
    asnDetailQuery: 'ASN Query',
    receiptDetailQuery: 'Receipt Query',
    inspectDetailQuery: 'inspect Query',
    receiptRejectDetailQuery: 'Receipt Reject Query',
    inspectRejectDetailQuery: 'inspect Reject Query',
    saleDetailQuery: 'Sale Query',
    shipmentDetailQuery: 'Shipment Query',
    countingDetailQuery: 'Counting Query',
    purchaseReturnDetailQuery: 'Purchase Return Query',
    saleReturnDetailQuery: 'Sale Return Query',
    commandQuery: 'Command Query',
    receiptCommandQuery: 'Receipt Command',
    shipmentCommandQuery: 'Shipment Command',
    replenishCommandQuery: 'Replenish Command',
    transferCommandQuery: 'Transfer Command',
    inventoryQuery: 'Inventory Query',
    ledgerQuery: 'Ledger',
    balanceQuery: 'Balance Query',
    balanceStatistics: 'Balance Statistics',
    locationUtilisation: 'Location Utilisation',
    statistics: 'Statistics'
  },
  title: {
    itemSearch: 'Item Search',
    zoneSearch: 'Zone Search',
    poPickup: 'PO Pickup',
    asnDetailEdit: 'ASN Detail Edit',
    approvalSearch: 'Approval Search',
    licenseSearch: 'License Search',
    permissionSearch: 'Permission Search',
    qualityStandardSearch: 'Quality Standard Search',
    practiceSearch: 'Practice Search',
    SupervisionCodeCollection: 'Supervision Code Collection',
    ReturnDetailSearch: 'Return Detail Search',
    ReceiptDetailSearch: 'Receipt Detail Search',
    returnPickup: 'Return Pickup',
    asnPickup: 'ASN Pickup',
    itemPackMaintain: 'Item Pack Maintain',
    countingAdd: 'Counting Add',
    quantity: 'quantity',
    targetStorageRoom: 'Target Storage Room',
    moveInLocation: 'Move In Location',
    targetLogicalStore: 'Target Logical Store',
    reason: 'Reason',
    inventoryLock: 'Inventory Lock',
    replenishmentQuantity: 'Replenishment Quantity',
    containerSearch: 'Container Search',
    locationSearch: 'location Search',
    lotSearch: 'lot Search',
    modelSearch: 'Model Search',
    barcodeSearch: 'Barcode Search',
    serialNumberSearch: 'SerialNumber Search',
    inventorSearch: 'Inventor Search',
    receiptDetailEdit: 'Receipt Detail Edit',
    menuSearch: 'Menu Search',
    recentlyVisited: 'Recently Visited',
    detailInvert: 'Detail Invert',
    shipmentBarcodeSearch: 'Shipment Barcode Search',
    userSearch: 'User Search',
    unqualifiedQuantity: 'Unqualified Quantity',
    unqualifiedReason: 'Unqualified Reason',
    itemInventorSearch: 'Item Inventor Search',
    activeReplenishmentPickUp: 'Active Replenishment Pick Up',
    supplyQuantityMaintain: 'Supply Quantity Maintain',
    inboundScan: 'Inbound Scan',
    inboundComplete: 'Inbound Complete',
    seedingPositionBind: 'Seeding Position Bind',
    autoTaskUserConfig: 'Auto Task User Config',
    storageRoomSearch: 'Storage Room Search',
    loadingOrderEdit: 'Loading Order Edit',
    loadingDetailEdit: 'Loading Detail Edit',
    customerSearch: 'Customer Search',
    coldChainEdit: 'Cold Chain Edit',
    deleteDetail: 'Delete Detail',
    cancelOrder: 'Cancel Order',
    skuSearch: 'SKU Search',
    conveyorSearch: 'Conveyor Search'
  },
  span: {
    orderNo: 'order No:',
    owner: 'owner:',
    proposer: 'proposer:',
    applicationAdvice: 'application Advice:',
    maintenanceQuantity: 'Maintenance Quantity',
    maintenanceMeasure: 'Maintenance Measure',
    maintenanceAdvice: 'Maintenance Advice'
  },
  option: {
    true: 'True',
    false: 'False',
    visual: 'Visual',
    artificial: 'Artificial',
    hasCollection: 'Has Collection',
    notCollection: 'Not Collection',
    hasReview: 'Has Review',
    notReview: 'Not Review',
    outboundCounting: 'Outbound Counting',
    notOutboundCounting: 'Not Outbound Counting'
  }
}
